import { Icon, styled } from '@material-ui/core';
import { Box } from '@mui/material';

export const MainBody = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: '20px 0px',
  '& video': {
    height: '500px',
    objectFit: 'cover',
  },
  '& img': {
    height: '500px',
    objectFit: 'cover',
  },
  '& .material-icons': {
    position: 'absolute',
    bottom: '30px',
    right: '10px',
    cursor: 'pointer',

    '& svg': {
      fill: '#fff !important',
    },
  },
  userSelect: 'none',
}));

export const VideoCont = styled('div')(() => ({
  width: '100%',
  maxHeight: '100vh',
  objectFit: 'contain',
  cursor: 'pointer',

  '& video': {
    maxHeight: '100vh',
  },
}));

export const Image = styled('img')(() => ({
  width: '100%',
  height: '600px',
  objectFit: 'contain',
  cursor: 'pointer',
}));

export const BodyMultiChilds = styled(MainBody)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
}));

export const BodyTwoChilds = styled(BodyMultiChilds)(() => ({
  '& > *:nth-child(1)': {
    flex: '0 1 50%',
    width: '50%',
    height: '500px',
  },

  '& > *:nth-child(2)': {
    flex: '0 1 50%',
    width: '50%',
    height: '500px',
  },
}));

export const BodyThreeChilds = styled(BodyMultiChilds)(() => ({
  '& > *:nth-child(1)': {
    flex: '0 1 50%',
    width: '50%',
    height: '400px',
  },

  '& > *:nth-child(2)': {
    flex: '0 1 50%',
    width: '50%',
    height: '400px',
  },

  '& > *:nth-child(3)': {
    flex: '0 1 100%',
    width: '100%',
    height: '300px',
  },
}));

export const BodyFourChilds = styled(BodyMultiChilds)(() => ({
  '& > *:nth-child(1)': {
    flex: '0 1 50%',
    width: '50%',
    height: '300px',
  },

  '& > *:nth-child(2)': {
    flex: '0 1 50%',
    width: '50%',
    height: '300px',
  },

  '& > *:nth-child(3)': {
    flex: '0 1 50%',
    width: '50%',
    height: '300px',
  },

  '& > *:nth-child(4)': {
    flex: '0 1 50%',
    width: '50%',
    height: '300px',
  },
}));

export const BodyFiveChilds = styled(BodyMultiChilds)(() => ({
  '& > *:nth-child(1)': {
    flex: '0 1 50%',
    width: '50%',
    height: '300px',
  },

  '& > *:nth-child(2)': {
    flex: '0 1 50%',
    width: '50%',
    height: '300px',
  },

  '& > *:nth-child(3)': {
    flex: '0 1 33.333%',
    width: '33.333%',
    height: '300px',
  },

  '& > *:nth-child(4)': {
    flex: '0 1 33.333%',
    width: '33.333%',
    height: '300px',
  },

  '& > *:nth-child(5)': {
    flex: '0 1 33.333%',
    width: '33.333%',
    height: '300px',
  },
}));

export const BodyMoreChilds = styled(BodyFiveChilds)(() => ({
  '& > *:nth-child(5)': {
    position: 'relative',
    flex: '0 1 33.333%',
    width: '33.333%',
    height: '300px',

    '&::after': {
      position: 'absolute',
      content: '',
      top: '0px',
      left: '0px',
      width: '100%',
      height: '100%',
      background: 'rgba(0, 0, 0, 0.5)',
    },
    '& ~ *:not(.show)': {
      display: 'none',
    },
  },
}));

export const ImageNumberDisplay = styled('div')(() => ({
  position: 'absolute',
  bottom: '20px',
  right: '0px',
  width: '33.333%',
  height: '300px',
  background: 'rgba(0, 0, 0, 0.8)',
  zIndex: 10,
  cursor: 'pointer',

  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  '& p': {
    margin: '0px',
    color: '#fff',
    fontSize: '3rem',
    height: 'fit-content !important',
    textAlign: 'center',
    fontFamily: 'lato',
  },
}));

export const VideoContFull = styled('div')(() => ({
  width: '100%',
  height: '100%',
  maxHeight: '100%',
  objectFit: 'contain',
  cursor: 'pointer',

  '& video': {
    maxHeight: '100vh',
    height: '100%',
  },
}));

export const FullscreenCont = styled(Box)(({ theme }) => ({
  position: 'fixed',
  height: '100vh',
  width: '100vw',
  top: '0px',
  left: '0px',
  zIndex: 1000,
  '& video': {
    height: '100%',
    width: '100%',
    objectFit: 'contain',
    zIndex: 1001,
  },
  '& img': {
    height: '100%',
    width: '100%',
    objectFit: 'contain',
    zIndex: 1001,
  },
  '& .close-icon': {
    position: 'absolute',
    top: '15px',
    right: '30px',
    cursor: 'pointer',

    '& svg': {
      fill: '#fff !important',
    },
    zIndex: 1005,
  },
  '& .backdrop': {
    position: 'absolute',
    top: '0px',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,.5)',
    zIndex: -1,
  },
}));

export const RightIcon = styled(Icon)(() => ({
  position: 'absolute',
  height: '50px',
  width: '50px',
  top: '50%',
  right: '25px',
  zIndex: 1005,
  cursor: 'pointer',
  display: 'grid',
  placeItems: 'center',
  backgroundColor: 'rgba(255,255,255,.5)',
  borderRadius: '50%',

  '& svg': {
    fill: '#fff !important',
  },
}));

export const LeftIcon = styled(RightIcon)(() => ({
  left: '10px',
}));
